/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useRef } from 'react';

import { FormikErrors, FormikProps } from 'formik';

import { GA_EVENTS } from '@pharmaplan/common';

import useAnalytics from '../../analytics/useAnalytics';

interface IUseSignupErrors {
  formik: FormikProps<any>;
}

const useSignupErrors = ({ formik }: IUseSignupErrors) => {
  const analytics = useAnalytics();
  const { errors, touched } = formik;

  const triedSubmit = useRef(false);

  const formatError = (inError: FormikErrors<any>) =>
    Object.keys(inError).reduce((acc, curr) => {
      // eslint-disable-next-line no-param-reassign
      acc += `${curr}:${inError[curr]}\n`;
      return acc;
    }, '');

  useEffect(() => {
    if (
      Object.keys(errors).length
      && Object.keys(touched).length
      && !triedSubmit.current
    ) {
      triedSubmit.current = true;
      analytics?.logCustomEvent({
        event: GA_EVENTS.signupError,
        error_message: formatError(errors),
      });
    }
  }, [analytics, errors, touched]);

  useEffect(() => {
    if (!Object.keys(errors).length) {
      triedSubmit.current = false;
    }
  }, [errors]);
};

export default useSignupErrors;
